export enum MessageDeliveryChannel {
  email = 'email',
  sms = 'sms',
}
